<template>
  <div>
    <div class="app-main-inner-row" style="padding-top: 10px;">
      <div class="filters">
        <el-form
          :inline="true"
          label-width="50px"
          label-position="left"
          @submit.native.prevent="filter.pageNum=1;toQuery()"
        >
          <el-form-item :label="$t('common.btn.query')">
            <el-input
              v-model="filter.likeName"
              no="queryInput"
              :placeholder="$t('CargoMsg.QuickSearchMsgClassify')"
              style="width:310px"
            />
          </el-form-item>
        </el-form>
      </div>
      <div class="triggers">
        <el-button no="query" type="primary" @click="filter.pageNum=1;toQuery()">{{ $t('common.btn.query') }}</el-button>
        <el-button no="new" type="primary" @click="showEditDialog(true)">{{ $t('common.btn.new') }}</el-button>
        <el-button no="edit" type="primary" @click="showEditDialog(false)">{{ $t('common.btn.edit') }}</el-button>
        <el-button no="delete" type="danger" @click="remove">{{ $t('common.btn.delete') }}</el-button>
      </div>
    </div>
    <div class="app-main-inner-row row-grid">
      <cargo-ag-grid
        no="grid"
        config-module="102500"
        :grid-params.sync="girdParams"
        :grid-options="gridOptions"
        :column-defs="columnDefs"
        :row-data="rowData"
      />
    </div>
    <div class="app-main-inner-row row-pagination">
      <cargo-pagination
        v-show="total>0"
        no="pagination"
        :total="total"
        :page.sync="filter.pageNum"
        :limit.sync="filter.pageSize"
        @pagination="toQuery"
      />
    </div>
    <!-- 编辑弹窗 -->
    <el-dialog
      v-el-drag-dialog
      :visible.sync="editDialog.visible"
      :title="editDialog.title"
      width="500px"
      :close-on-click-modal="false"
    >
      <div class="app-main-inner-row" style="padding-bottom: 10px;">
        <el-form label-width="110px" label-position="left">
          <el-form-item :label="$t('CargoMsg.Cargo_SequenceNumber')">
            <el-input-number
              v-model="editDialog.form.serialNumber"
              no="serialNumber"
              :min="1"
              :precision="0"
              controls-position="right"
              style="width: 162px"
              @blur="serialNumberBlur"
            />
          </el-form-item>
          <el-form-item :label="$t('CargoMsg.Cargo_ServiceProductID')">
            <el-input v-model="editDialog.form.productId" no="productId" :disabled="tenantId!==PLATFORM_TENANT_ID" />
          </el-form-item>
          <el-form-item :label="$t('CargoMsg.Cargo_ServiceProductName')">
            <el-input v-model="editDialog.form.productName" no="productName" :disabled="tenantId!==PLATFORM_TENANT_ID" />
          </el-form-item>
          <el-form-item :label="$t('CargoMsg.Cargo_ForceRoutingBooking')">
            <el-select
              v-model="editDialog.form.forceAirlineBooking"
              style="width:200px"
              no="forceAirlineBooking"
            >
              <el-option
                v-for="(item, index) in YES_NO_TYPES"
                :key="index"
                :label="$getLangColumn(item)"
                :value="item.code"
              />
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('CargoMsg.Cargo_AirServiceProduct')">
            <el-select
              v-model="editDialog.form.isAirlineProduct"
              style="width:200px"
              no="isAirlineProduct"
            >
              <el-option
                v-for="(item, index) in YES_NO_TYPES"
                :key="index"
                :label="$getLangColumn(item)"
                :value="item.code"
              />
            </el-select>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer">
        <el-button no="editSave" type="primary" @click="save">{{ $t('common.btn.save') }}</el-button>
        <el-button no="editCancel" @click="editDialog.visible=false">{{ $t('common.btn.cancel') }}</el-button>
      </span>
    </el-dialog>
    <!-- 新增弹窗（非平台维护） -->
    <el-dialog
      v-el-drag-dialog
      :visible.sync="platformDialog.visible"
      :title="$t('CargoMsg.Cargo_AddBasicAirFreightServiceProduct')"
      width="950px"
      :close-on-click-modal="false"
    >
      <base-air-service-product />
      <span slot="footer">
        <el-button no="save" type="primary" @click="addFromPlatform">{{ $t('common.btn.save') }}</el-button>
        <el-button no="cancel" @click="platformDialog.visible=false">{{ $t('common.btn.cancel') }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import baseAirServiceProduct from './baseAirServiceProduct'
import { getUserInfo } from '@/utils/auth'
import { getAirServiceProductList, getAirServiceProductsByPlatform, saveAirServiceProduct, addAirServiceProductByPlatform, saveAirServiceProducts, delAirServiceProduct } from '@/api/basicData/airServiceProduct'
import { getLoading } from '@/utils/utilBaseElement'
import { YES_NO_TYPES } from '@/class/cargo/model/parameters/RadioStatusConstants'
import ColumnUtils from '@/utils/ColumnUtils'

export default {
  name: 'AirServiceProduct',
  components: { baseAirServiceProduct },
  data() {
    return {
      YES_NO_TYPES,
      PLATFORM_TENANT_ID: 1, // 平台维护的租户ID
      filter: {
        likeName: '',
        pageNum: 1,
        pageSize: 50
      },
      total: 0,
      girdParams: {},
      gridOptions: {
        rowSelection: 'multiple',
        suppressCellSelection: true,
        context: {
          componentParent: this
        },
        defaultColDef: {
          menuTabs: [], // 去掉每列的菜单
          filter: true
        }
      },
      columnDefs: [
        {
          headerName: '',
          checkboxSelection: true,
          width: 55,
          sortable: false,
          suppressMenu: true,
          suppressSizeToFit: true,
          resizable: false,
          headerCheckboxSelection: true
        },
        {
          headerName: this.$t('CargoMsg.Cargo_SequenceNumber'),
          field: 'serialNumber',
          width: 100
        },
        {
          headerName: this.$t('CargoMsg.Cargo_ServiceProductID'),
          field: 'productId',
          width: 200
        },
        {
          headerName: this.$t('CargoMsg.Cargo_ServiceProductName'),
          field: 'productName',
          width: 200
        },
        {
          headerName: this.$t('CargoMsg.Cargo_ForceRoutingBooking'),
          field: 'forceAirlineBooking',
          width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.showTypeLabelFunc(params.value, YES_NO_TYPES)
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_UsedAsRoutingProduct'),
          field: 'isAirlineProduct',
          width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.showTypeLabelFunc(params.value, YES_NO_TYPES)
          }
        }
      ],
      rowData: null,
      tenantId: '',
      editDialog: {
        visible: false,
        title: '',
        form: {
          uuid: '',
          serialNumber: '',
          productId: '',
          productName: '',
          forceAirlineBooking: false,
          isAirlineProduct: false
        }
      },
      platformDialog: {
        visible: false
      }
    }
  },
  computed: {
    gridApi() {
      return this.girdParams.api
    }
  },
  created() {
    const user = getUserInfo()
    this.tenantId = user.tenantId
  },
  methods: {
    onShow() {
      if (this.rowData === null) {
        this.rowData = []
        this.toQuery()
      }
    },
    toQuery() {
      const self = this
      let queryFunc = getAirServiceProductList
      if (self.tenantId === self.PLATFORM_TENANT_ID) {
        queryFunc = getAirServiceProductsByPlatform
      }
      const loading = getLoading()
      queryFunc(self.filter).then(res => {
        if (self.gridApi) {
          self.gridApi.setRowData(res.data.list)
        } else {
          self.rowData = res.data.list
        }
        self.filter.pageNum = res.data.pageNum
        self.filter.pageSize = res.data.pageSize
        self.total = Number(res.data.total)
      }).finally(() => loading.close())
    },
    showEditDialog(isNew) {
      if (isNew) {
        if (this.tenantId !== this.PLATFORM_TENANT_ID) {
          this.showPlatform()
          return
        }
        this.editDialog.form = {
          uuid: '',
          serialNumber: '',
          productId: '',
          productName: '',
          forceAirlineBooking: false,
          isAirlineProduct: false
        }
        this.editDialog.title = this.$t('CargoMsg.Cargo_NewTo') + this.$t('CargoMsg.Cargo_AirServiceProduct')
      } else {
        const rows = this.gridApi.getSelectedRows()
        if (rows.length === 0) {
          this.$message.warning(this.$t('common.tips.hasOneAtleast'))
          return
        }
        this.editDialog.form = { ...rows[0] }
        this.editDialog.title = this.$t('CargoMsg.Cargo_EditTo') + this.$t('CargoMsg.Cargo_AirServiceProduct')
      }
      this.editDialog.visible = true
    },
    serialNumberBlur() {
      const form = this.editDialog.form
      const val = Number(form.serialNumber)
      if (isNaN(val)) {
        form.serialNumber = ''
        return
      }
      form.serialNumber = val.toFixed(0)
    },
    save() {
      const self = this
      const form = self.editDialog.form
      if (!form.serialNumber && Number(form.serialNumber) != 0) {
        self.$message.warning(self.$t('CargoMsg.Cargo_PlsInput') + this.$t('CargoMsg.Cargo_SequenceNumber'))
        return
      }
      if (!form.productId) {
        self.$message.warning(self.$t('CargoMsg.Cargo_PlsInput') + this.$t('CargoMsg.Cargo_ServiceProductID'))
        return
      }
      if (!form.productName) {
        self.$message.warning(self.$t('CargoMsg.Cargo_PlsInput') + this.$t('CargoMsg.Cargo_ServiceProductName'))
        return
      }
      let saveFunc = saveAirServiceProduct
      if (!form.uuid && self.tenantId === self.PLATFORM_TENANT_ID) {
        saveFunc = addAirServiceProductByPlatform
      }
      saveFunc(form).then(res => {
        if (!form.uuid) {
          self.filter.pageNum = 1
        }
        self.toQuery()
        self.editDialog.visible = false
        self.$message.success(self.$t('common.tips.saveSuccess'))
      }).catch(() => {
        self.editDialog.visible = false
      })
    },
    remove() {
      const self = this
      const rows = self.gridApi.getSelectedRows()
      if (rows.length === 0) {
        self.$message.warning(self.$t('common.tips.hasOneAtleast'))
        return
      }
      self.$confirm(self.$t('CargoMsg.Cargo_DeleteServiceProductWarning', [rows.length]), self.$t('common.tips.prompt'), {
        confirmButtonText: self.$t('common.btn.ok'),
        cancelButtonText: self.$t('common.btn.cancel'),
        type: 'warning'
      }).then(() => {
        const uuids = Array.from(rows, p => p.uuid)
        delAirServiceProduct(uuids).then(res => {
          self.filter.pageNum = 1
          self.toQuery()
          self.$message.success(self.$t('common.tips.deleteSuccess'))
        })
      }).catch(() => { })
    },
    showPlatform() {
      if (document.resetBaseAirServiceProduct) {
        document.resetBaseAirServiceProduct()
      } else {
        setTimeout(() => {
          document.resetBaseAirServiceProduct()
        })
      }
      this.platformDialog.visible = true
    },
    addFromPlatform() {
      const self = this
      const rows = document.getSelectedBaseAirServiceProductRows()
      if (rows.length === 0) {
        self.$message.warning(self.$t('common.tips.hasOneAtleast'))
        return
      }
      const form = []
      for (let i = 0; i < rows.length; ++i) {
        const item = rows[i]
        form.push({
          serialNumber: item.serialNumber,
          productId: item.productId,
          productName: item.productName,
          forceAirlineBooking: item.forceAirlineBooking,
          isAirlineProduct: item.isAirlineProduct
        })
      }
      saveAirServiceProducts(form).then(res => {
        self.filter.pageNum = 1
        self.toQuery()
        self.platformDialog.visible = false
        self.$message.success(self.$t('common.tips.saveSuccess'))
      }).catch(() => {
        self.platformDialog.visible = false
      })
    }
  }
}
</script>

<style>
</style>
